import { render, staticRenderFns } from "./cognitoClientList.vue?vue&type=template&id=ed8bdafa&"
import script from "./cognitoClientList.vue?vue&type=script&lang=js&"
export * from "./cognitoClientList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports